module.exports = __webpack_public_path__ + "img/statue-life.01266fa5.png";